const titel = [
    { value: 'Dr.', text: 'Dr.' },
    { value: 'Prof.', text: 'Prof.' },
    { value: '-', text: '-' }
]

export default titel;